<button [ngClass]="['card-container', state]" (click)="onCardClick()">
  <app-icon [svgIcon]=" icon || 'aerosol'" [class]="'icon-card'"></app-icon>
  <span class="body-s text-color">{{ text }}</span>
</button>
